(function () {
    'use strict';

    run.parts.logoutConfirm = function() {
        addCustomEventListener('.link_logout', 'click', confirmLogout);

        function confirmLogout(e)
        {
            e.preventDefault();
            var _location = e.target.closest('a').href;

            Swal.fire({
                title: translations.confirmAlerts.logout.confirmTitle,
                html: '',
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.confirmAlerts.logout.cancel,
                confirmButtonText: translations.confirmAlerts.logout.confirm,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.value) {
                    window.location.href = _location;
                }
            });
        }
    };
})();